import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id/general/")({
  staticData: {
    title: "common.general",
  },
});
